import { useTranslation } from 'react-i18next'

import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

interface RevealPasswordModalProps {
  password: string
  onClose: () => void
}

const RevealPasswordModal = ({ password, onClose }: RevealPasswordModalProps) => {
  const { t } = useTranslation()

  return (
    <SDModal
      isOpen={!!password}
      openHandler={onClose}
      title={t('websalesUsersManagement:modal.regenerated_password_header')}
      sections={
        <>
          <SDNotification
            type='warning'
            primaryText={t('websalesUsersManagement:modal.regenerated_password_warning')}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
            {/* @ts-expect-error SDInput is a JS component */}
            <SDInput
              id='websales-user-regenerated-password'
              currentValue={password}
              outerOnchange={() => {}}
            />
            <CopyEndEnhancer value={password} />
          </div>
          {/* @ts-expect-error SDButton is a JS component */}
          <SDButton block={false} onClick={onClose}>
            {t('websalesUsersManagement:modal.regenerated_password_confirm')}
          </SDButton>
        </>
      }
    />
  )
}

export default RevealPasswordModal
